"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
function ClassroomPanel(props) {
    const { users, expandChanged, className } = props;
    const [expanded, setExpanded] = (0, react_1.useState)(false);
    const expandChangedHandler = (0, react_1.useCallback)((value) => {
        setExpanded(value);
        expandChanged(value);
    }, [setExpanded, expandChanged]);
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, onClick: () => !expanded && expandChangedHandler(true), "data-e2e": 'ClassroomPanel_Container', children: [(0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'ClassroomPanel_Title', children: (0, i18n_1.Localized)(i18n_1.Strings.liveMode.classroom.hostingTitle) }), (0, jsx_runtime_1.jsx)(Subtitle, { "data-e2e": 'ClassroomPanel_Subtitle', children: (0, i18n_1.Localized)(i18n_1.Strings.liveMode.classroom.usersCount, {
                    count: users.length,
                }) }), expanded ? ((0, jsx_runtime_1.jsxs)(UserList, { "data-e2e": 'ClassroomPanel_UserList', children: [(0, jsx_runtime_1.jsx)(StyledScrollView, { "data-e2e": 'ClassroomPanel_StyledScrollView', children: users.map((user, index) => {
                            return ((0, jsx_runtime_1.jsxs)(UserListItem, { "data-e2e": 'ClassroomPanel_UserListItem', children: [(0, jsx_runtime_1.jsx)(VerticalAvatar, { image: user.avatar, "data-e2e": 'ClassroomPanel_VerticalAvatar' }), user.name] }, index));
                        }) }), (0, jsx_runtime_1.jsx)(CloseListButton, { onClick: () => expandChangedHandler(false), "data-e2e": 'ClassroomPanel_CloseListButton', children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.Arrow_Up, width: 16, height: 16, "data-e2e": 'ClassroomPanel_Icon' }) })] })) : ((0, jsx_runtime_1.jsx)(AvatarsContainer, { "data-testid": "avatar-container", "data-e2e": 'ClassroomPanel_AvatarsContainer', children: users.map((user, index) => {
                    return (0, jsx_runtime_1.jsx)(HorizontalAvatar, { image: user.avatar, "data-e2e": 'ClassroomPanel_HorizontalAvatar' }, index);
                }) }))] }));
}
exports.default = ClassroomPanel;
const Container = styled_components_1.default.div `
  position: absolute;
  top: 10px;
  right: 10px;

  display: flex;
  flex-direction: column;

  min-width: 140px;
  padding: 10px 10px 0 10px;

  color: ${({ theme }) => theme.white};

  background: ${({ theme }) => theme.mediumTurquoise_50};
  border-radius: 2px;

  cursor: pointer;

  pointer-events: auto;
`;
const Title = styled_components_1.default.div `
  margin: 0 auto;

  color: ${({ theme }) => theme.white};
  font-weight: bold;
  font-size: 11px;
`;
const Subtitle = styled_components_1.default.div `
  margin: 0 auto;

  color: ${({ theme }) => theme.white};
  font-size: 11px;
`;
const AvatarsContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  box-sizing: border-box;
  min-width: 100%;
  margin: 0;
  padding: 10px 20px 10px 10px;
`;
const StyledAvatar = (0, styled_components_1.default)(ui_1.Avatar) `
  width: 30px;
  height: 30px;

  background: ${({ theme }) => theme.white};
  border-radius: 50%;
  box-shadow: 0 1px 2px 0 ${({ theme }) => theme.black_50};
`;
const HorizontalAvatar = (0, styled_components_1.default)(StyledAvatar) `
  margin: auto -10px auto 0;

  &:nth-last-child(n + 9) {
    display: none;
  }

  &:nth-last-child(n + 8) {
    opacity: 0.6;
  }

  &:nth-last-child(n + 7) {
    opacity: 0.8;
  }
`;
const VerticalAvatar = (0, styled_components_1.default)(StyledAvatar) `
  margin: auto 10px auto 0;
`;
const UserList = styled_components_1.default.div `
  position: absolute;
  top: 100%;
  right: 0;
  left: 0;

  display: flex;
  flex-direction: column;
  max-height: 300px;
  padding: 10px 10px 20px 10px;
  overflow: hidden;

  background-color: ${({ theme }) => theme.mediumTurquoise_50};
`;
const StyledScrollView = (0, styled_components_1.default)(ui_1.ScrollView) `
  display: flex;
  flex-direction: column;

  width: 100%;
`;
const UserListItem = styled_components_1.default.div `
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 50px;

  color: ${({ theme }) => theme.white};
  font-size: 12px;
`;
const CloseListButton = styled_components_1.default.div `
  position: absolute;
  bottom: 0px;
  left: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 44px;
  height: 36px;
  margin: 0 0 0 -22px;

  color: ${({ theme }) => theme.white};
`;
